import request from "./request";
import { ENV_CONFIG } from '@/config';

// 相对路径（API 网关），暂保留；实际请求由下方 directApi 覆盖为直连后端
let api = {
  getDrainage: "/Program/Live/getDrainage", // 获取app引流配置
  getChannelInfo: "/Program/Index/getTvChannelInfo", // 获取直播间配置
  getPlayAddress: "/tv/getPlayAddress", // 防盗链接口
  getMenuList: "/Program/Index/getTvMenuList", // 获取菜单配置
  getWatchLoginInfo: "/Program/Index/getTvWatchLoginInfo", // 获取登录信息
  PostInfo: "/Program/Live/PostInfo", // 数据统计相关
  getListByChannel: "/programme/Index/getListByChannel", // 获取节目的
  getBillPlayInfo: "/programme/Index/getBillPlayInfo", // 获取节目的视频
  getPlaylistList: "/Program/Index/getPlaylistList", // 获得播单
  getChatList: "/Program/Chat/getTvChatList", // 获取连天内容
  getTopChatList: "/Program/Chat/getTvTopChatList", // 获取置顶聊天内容
  sendChat: "/Program/Chat/sendTvChat", // 发送聊
  sendAudio: "/Program/Chat/sendAudio",
  sendPhoto: "/Program/Chat/sendTvPhoto", // 发送图片
  sendPhotoByWeixin: "/Program/Chat/sendTvPhotoByWeixin", // 微信发送图片
  getWxJsapiPackage: "/Program/Share/getWxJsapiPackage", // 获取微信sdk
  getGlobalSetting: "/Program/Person/getUserGlobalSetting", // 获取全局配置
  getUserBaseConfig: '/Program/Person/getUserBaseConfig' // 获取B端用户基础信息
};

// 阿里云 FC 代理到 node-api 的路径按环境区分；其余接口统一直连后端域名
const nodeApiProxy =
  !ENV_CONFIG.X_CA_STAGE
    ? "node-api.online/node-api"
    : ENV_CONFIG.X_CA_STAGE === "PRE"
      ? "node-api/node-api"
      : "node-api/node-api-test"; // TEST

const directApi = {
  getDrainage: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Live/getDrainage`, // 获取app引流配置
  getChannelInfo: `https://${ENV_CONFIG.FUNCTION_API_DOMAIN}/2016-08-15/proxy/${nodeApiProxy}/tv/channelInfo`, // 获取直播间配置
  getPlayAddress: `https://${ENV_CONFIG.FUNCTION_API_DOMAIN}/2016-08-15/proxy/${nodeApiProxy}/tv/getPlayAddress`, // 防盗链接口 获取播放地址
  getMenuList: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Index/getTvMenuList`, // 获取菜单配置
  getWatchLoginInfo: `https://${ENV_CONFIG.FUNCTION_API_DOMAIN}/2016-08-15/proxy/${nodeApiProxy}/tv/watchLoginInfo`, // 获取登录信息
  PostInfo: `https://${ENV_CONFIG.GO_API_DOMAIN}/v1/live/postinfo`, // 数据统计相关
  getListByChannel: `https://${ENV_CONFIG.PROGRAMME_API_DOMAIN}/v1/programme/Index/getListByChannel`, // 获取节目的
  getBillPlayInfo: `https://${ENV_CONFIG.PROGRAMME_API_DOMAIN}/v1/programme/Index/getBillPlayInfo`, // 获取节目的视频
  getPlaylistList: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Index/getPlaylistList`, // 获得播单
  getChatList: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Chat/getTvChatList`, // 获取连天内容
  getTopChatList: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Chat/getTvTopChatList`, // 获取置顶聊天内容
  sendChat: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Chat/sendTvChat`, // 发送聊
  sendAudio: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Chat/sendAudio`, // 发送语音
  sendPhoto: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Chat/sendTvPhoto`, // 发送图片
  sendPhotoByWeixin: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Chat/sendTvPhotoByWeixin`, // 微信发送图片
  getWxJsapiPackage: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Share/getWxJsapiPackage`, // 获取微信sdk
  getGlobalSetting: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Person/getUserGlobalSetting`, // 获取全局配置
  getUserBaseConfig: `https://${ENV_CONFIG.PRIVATE_API_DOMAIN}/v1/Program/Person/getUserBaseConfig`, // 获取B端用户基础信息
};

api = { ...api, ...directApi };

export const getDrainage = (data) => {
  return request.get(api["getDrainage"], data);
};
export const getChannelInfo = (data) => {
  return request.get(api["getChannelInfo"], data);
};
export const getMenuList = (data) => {
  return request.get(api["getMenuList"], data);
};
export const getWatchLoginInfo = (data) => {
  return request.get(api["getWatchLoginInfo"], data);
};
export const PostInfo = (data) => {
  return request.post(api["PostInfo"], data);
};
export const getListByChannel = (data) => {
  return request.get(api["getListByChannel"], data);
};
export const getBillPlayInfo = (data) => {
  return request.get(api["getBillPlayInfo"], data);
};
export const getPlaylistList = (data) => {
  return request.get(api["getPlaylistList"], data);
};
export const getChatList = (data) => {
  return request.get(api["getChatList"], data);
};
export const getTopChatList = (data) => {
  return request.get(api["getTopChatList"], data);
};
export const sendChat = (data) => {
  return request.post(api["sendChat"], data);
};
export const sendAudio = (data) => {
  return request.post(api["sendAudio"], data, {
    headers: { "Content-Type": "multipart/form-data;charset=UTF-8" },
  });
};
export const sendPhoto = (data) => {
  return request.post(api["sendPhoto"], data);
};
export const sendPhotoByWeixin = (data) => {
  return request.post(api["sendPhotoByWeixin"], data);
};
export const getWxJsapiPackage = (data) => {
  return request.post(api["getWxJsapiPackage"], data);
};
export const shareSuccessBack = (data) => {
  return request.post(api["shareSuccessBack"], data);
};
export const getPlayAddress = (data) => {
  return request.get(api["getPlayAddress"], data);
};
export const getGlobalSetting = (data) => {
  return request.get(api["getGlobalSetting"], data);
};
export const getUserBaseConfig = (data) => {
  return request.get(api['getUserBaseConfig'], data)
}
export default {
  getDrainage,
  getChannelInfo,
  getMenuList,
  getWatchLoginInfo,
  PostInfo,
  getListByChannel,
  getBillPlayInfo,
  getPlaylistList,
  getChatList,
  getTopChatList,
  sendChat,
  sendPhoto,
  sendPhotoByWeixin,
  getWxJsapiPackage,
  shareSuccessBack,
  getPlayAddress,
  sendAudio,
  getGlobalSetting,
  getUserBaseConfig
};
